import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import  './IpResults.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

function IpResults({searchVal}){

    const [cordinatesLat, setCordinatesLat] = useState("");
    const [cordinatesLong, setCordinatesLong] = useState("");
   
    // console.log("fdfdfd: " + i++);
    // if(searchVal){
    //     console.log('its true');
    // }

    const accessKey = 'dad59b9f322502191bd402f13fb323fd';


    const [ipData, setIpData] = useState([]);
   

    useEffect(() => {
       
        if(searchVal){
            
        
            
            fetch("https://geo.ipify.org/api/v1?apiKey=at_2LhD2DI8ecahI3KjN5NBWGmjNisW0&ipAddress=" + searchVal)
            .then(response  => response.json())
            .then((data) => {
                console.log(data)
                setIpData(data)
                
                
            }) 
            .catch(error => {
                setIpData({errorMsg: "There has been a problem with your fetch operation"});
                console.error('There has been a problem with your fetch operation:', error);
            }); 
            
           
            
        } else {


            fetch("https://geo.ipify.org/api/v1?apiKey=at_2LhD2DI8ecahI3KjN5NBWGmjNisW0&ipAddress=8.8.8.8")
            .then(response  => response.json())
            .then((data) => {
                console.log(data)

                setIpData(data)
                
                
            }) 
            .catch(error => {
                
                setIpData({errorMsg: "There has been a problem with your fetch operation"});
                console.error('There has been a problem with your fetch operation:', error);
            }); 

        }

        
        
    }, [searchVal])


    if(ipData.postalCode == null){
        ipData.postal = 'N/A'
    }

 
   
    
    return (
        <div>
            <div className="ip-results-wrapper">
            
      
                <div className="ip-results">
                {!ipData.location ? <p>Error with your request</p> : 
                <div className="data-wrapper">
                    
                        <div className="data-info"> 
                            <h5>IP ADDRESS</h5>
                            <p>{ipData.ip}</p>
                          

               
                            <h5>LOCATION</h5>
                            <p>{ipData.location.region}</p>
                       
                            
                        
                            <h5>City</h5>
                            <p>{ipData.location.city}</p>
                    

                
                            <h5>zip</h5>
                            <p>{ipData.location.postalCode} </p> 
                  

                  
                            <h5>Country</h5>
                            <p>{ipData.location.country} </p>
                    
                        </div> 
                   

                    

                <MapContainer style={{ background: '#aad3df'}} center={[ipData.location.lat, ipData.location.lng ]} zoom={2} scrollWheelZoom={true}>
                <TileLayer
                attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <Marker position={[ipData.location.lat, ipData.location.lng ]}>
                </Marker>
                </MapContainer>


                </div>
 
                }
                </div>
                
            </div> 



        </div>   
        
    )
}

export default IpResults;